import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";
import { IoArrowForward, IoLockClosedOutline, IoSendOutline } from "react-icons/io5";
import "../auth.css";

function PasswordPhoneNumberPage() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const sendOTP = () => {
    setIsLoading(true);
    fetch(`${API_URL}/password/phone`, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone_number: phoneNumber }),
    })
    .then(r => r.json())
    .then(data => {
      setIsLoading(false);
      if (data.success) {
        navigate('/password_recovery/otp', { state: { phoneNumber } });
      } else {
        toast.error(data.message || "حدث خطأ أثناء إرسال الرمز");
      }
    })
    .catch(() => {
      setIsLoading(false);
      toast.error("حدث خطأ أثناء إرسال الرمز");
    });
  };

  return (
    <div className="auth-screen" dir="rtl">
      <div className="auth-header">
        <button className="auth-back-btn" onClick={() => navigate('/login')}>
          <IoArrowForward size={20} />
        </button>
      </div>

      <div className="auth-content">
        <div className="auth-icon-hero">
          <div className="auth-icon-hero__circle">
            <IoLockClosedOutline size={34} />
          </div>
          <h1 className="auth-icon-hero__title">استرجاع كلمة المرور</h1>
          <p className="auth-icon-hero__sub">
            أدخل رقم هاتفك وسيصلك رمز تأكيد
          </p>
        </div>

        <div className="auth-group">
          <label className="auth-label">رقم الهاتف</label>
          <input
            className="auth-input"
            type="tel"
            inputMode="numeric"
            placeholder="أدخل رقم الهاتف"
            value={phoneNumber}
            onChange={e => setPhoneNumber(e.target.value)}
          />
        </div>

        <button
          className="auth-submit"
          disabled={isLoading || phoneNumber.length < 8}
          onClick={sendOTP}
        >
          {isLoading
            ? <span className="spinner-border spinner-border-sm" />
            : <IoSendOutline size={20} />
          }
          إرسال الرمز
        </button>
      </div>
    </div>
  );
}

export default PasswordPhoneNumberPage;
